/**
 * Compact one-line participant readiness summary (2026-09-26 consolidation).
 * Reads the canonical Participant Readiness Centre API; full findings live on the Readiness Centre page only.
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldCheck, ArrowRight } from 'lucide-react';
import api from '@/lib/api';
import { Button } from '@/components/ui/button';

const TONE = { RED: 'border-rose-200 bg-rose-50/60 text-rose-800', AMBER: 'border-amber-200 bg-amber-50/60 text-amber-800', GREEN: 'border-emerald-200 bg-emerald-50/60 text-emerald-800' };

export function ReadinessCentreSummary({ participantId }) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get(`/participants/${participantId}/readiness-centre`).then((r) => { if (alive) setData(r.data?.data || null); }).catch(() => { if (alive) setData(null); });
    return () => { alive = false; };
  }, [participantId]);
  if (!data) return null;
  const { open_items: open = 0, blocks = 0, warnings = 0 } = data.summary || {};
  const text = open === 0 ? (warnings ? `Setup complete · ${warnings} advisory item${warnings === 1 ? '' : 's'}` : 'Setup complete') : `${open} setup item${open === 1 ? '' : 's'} remaining${blocks ? ` · ${blocks} currently blocking a workflow` : ''}`;
  return (
    <div className={`flex items-center justify-between gap-3 rounded-md border px-3 py-2 text-sm ${TONE[data.overall] || TONE.GREEN}`} data-testid="readiness-centre-summary">
      <span className="flex items-center gap-2"><ShieldCheck className="h-4 w-4" /><span data-testid="readiness-centre-summary-text">{text}</span></span>
      <Button variant="ghost" size="sm" className="h-7 text-xs" onClick={() => navigate(`/participants/${participantId}/readiness-centre`)} data-testid="readiness-centre-summary-link">View Readiness Centre <ArrowRight className="h-3.5 w-3.5 ml-1" /></Button>
    </div>
  );
}

export default ReadinessCentreSummary;
